let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lX4S5")).then(() => parcelRequire('9q25v'));